import axios from '../../../../../../axiosRetail'
import { getListAgency as getListAgencyCommon } from '../../../../../utils/Apis/Agency/agencyApis'
const link = '/materials'
const apiPrefix = '/material'

const getListIngredient = data => {
  return axios({
    url: apiPrefix + '/list',
    method: 'POST',
    data: {
      ...data,
      link: link,
      idCategory: [-1],
      isPackage: [-1]
    }
  })
}

const getListAgency = () =>
  getListAgencyCommon({
    keySearch: '',
    page: 1,
    size: 99999,
    status: [2],
    type: 3
  })

const getDetailIngredient = id => {
  return axios({
    url: apiPrefix + '/detail',
    method: 'GET',
    params: {
      id: id,
      link: link
    }
  })
}

const addIngredient = data => {
  return axios({
    url: apiPrefix + '/create',
    method: 'POST',
    data: {
      ...data,
      link: link,
      barcode: '',
      description: '',
      isByPackage: false,
      maxInventory: 999999999,
      minInventory: 0,
      reqAgencies: [
        {
          key: 'de3251fc-0378-4465-9e46-0d0573a8289e',
          agencyId: [-1],
          reqClientResources: [
            {
              clientResourceId: 4,
              clientResourceName: 'Online',
              originPrice: 1000,
              sellingPrice: 1000
            },
            {
              clientResourceId: 2,
              clientResourceName: 'Trực tiếp',
              originPrice: 1000,
              sellingPrice: 1000
            }
          ],
          agencyDetails: [],
          priceShared: {
            originPrice: 1000,
            sellingPrice: 1000
          }
        }
      ],
      unitBasicId: 1000009,
      unitRequests: [],
      urlImage: "",
      type: 5,
      idCategories: [1000017]
    }
  })
}

const updateIngredient = data => {
  return axios({
    url: apiPrefix + '/update',
    method: 'POST',
    data: {
      ...data,
      link: link,
      barcode: '',
      description: '',
      isByPackage: false,
      maxInventory: 999999999,
      minInventory: 0,
      reqAgencies: [
        {
          key: 'de3251fc-0378-4465-9e46-0d0573a8289e',
          agencyId: [-1],
          reqClientResources: [
            {
              clientResourceId: 4,
              clientResourceName: 'Online',
              originPrice: 1000,
              sellingPrice: 1000
            },
            {
              clientResourceId: 2,
              clientResourceName: 'Trực tiếp',
              originPrice: 1000,
              sellingPrice: 1000
            }
          ],
          agencyDetails: [],
          priceShared: {
            originPrice: 1000,
            sellingPrice: 1000
          }
        }
      ],
      unitBasicId: 1000009,
      unitRequests: [],
      urlImage: "",
      type: 5,
      idCategories: [1000017]
    }
  })
}

const deleteIngredient = (id, status) => {
  return axios({
    url: apiPrefix + '/delete',
    method: 'POST',
    data: {
      ids: [id],
      status: status,
      link: link
    }
  })
}

const getListTypeSelect = () => {
  return axios({
    url: apiPrefix + '/list-select',
    method: 'GET',
    params: {
      type: 2,
      link: link
    }
  })
}

const materialHistoryList = (data) => {
  return axios({
    url: apiPrefix + '/material-history-list',
    method: 'POST',
    data: data
  })
}

const printTempMaterial = (data) => {
  return axios({
    url: apiPrefix + '/print-temp-material',
    method: 'POST',
    data: data
  })
}

const cancelMaterialWarning = (data) => {
  return axios({
    url: apiPrefix + '/cancel-material-warning',
    method: 'POST',
    data: data
  })
}

const checkWarning = (data) => {
  return axios({
    url: apiPrefix + '/check-warning',
    method: 'POST',
    data: data
  })
}

export {
  getListIngredient,
  getDetailIngredient,
  addIngredient,
  updateIngredient,
  deleteIngredient,
  getListTypeSelect,
  materialHistoryList,
  printTempMaterial,
  cancelMaterialWarning,
  checkWarning,
  getListAgency
}
